module.exports = {"130523100":"内丘镇","130523101":"大孟村镇","130523102":"金店镇","130523103":"官庄镇","130523104":"柳林镇","130523200":"五郭店乡","130523203":"南赛乡","130523204":"獐獏乡","130523205":"侯家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130523.json
// module id = 223
// module chunks = 0